import React, { useState } from 'react'
import { Col, Container, Row, Card, CardBody, ButtonDropdown, DropdownToggle, DropdownMenu } from 'reactstrap'
import { Doughnut } from 'react-chartjs-2';

import connectionIcon from 'assets/images/contacts_active_icon.png';
import expandArrow from 'assets/images/expand_arrow.png';

const Connections = (props) => {
    return (
        <>
            <div className="section-heading mb-3">Connections</div>
            <Card>
                <CardBody>
                    <div className="connections d-flex align-items-center mb-3">
                        <div className="connection-icon d-flex align-items-center justify-content-center">
                            <img src={connectionIcon} alt="#" />
                        </div>
                        <div className="flex-fill ml-3">
                            <div className="title">Total connections</div>
                            <div className="count">70</div>
                        </div>
                        <div className="expand-btn ml-2">
                            <img src={expandArrow} alt="#" />
                        </div>
                    </div>
                    <div className="mt-3">
                        <DashboardDonutChart />
                    </div>
                </CardBody>
            </Card>
        </>
    )
}

const DashboardDonutChart = () => {
    let data = {
        labels: [
            'Patients ',
            'Colleagues ',
            'Alumni'
        ],
        datasets: [{
            data: [21, 23, 26],
            backgroundColor: [
                '#35A7E3',
                '#ACB9FF',
                '#E5E9FF'
            ],
            hoverBackgroundColor: [
                '#35A7E3',
                '#ACB9FF',
                '#E5E9FF'
            ]
        }]
    };
    let option = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
            position: 'right',
            labels: {
                boxWidth: 12
            }
        }
    }
    return (
        <div className="donut-chart">
            <Doughnut data={data} options={option} />
        </div>
    )
}

export default Connections